import {
  cilBan,
  cilBoltCircle,
  cilCasino,
  cilEnvelopeClosed,
  cilGroup,
  cilHighlighter,
  cilHttps,
  cilReload,
  cilLibraryAdd,
  cilLockLocked,
  cilLockUnlocked,
  cilLowVision,
  cilMagnifyingGlass,
  cilMenu,
  cilMediaSkipBackward,
  cilMediaSkipForward,
  cilMoon,
  cilPlus,
  cilSpeedometer,
  cilStorage,
  cilSun,
  cilThumbDown,
  cilThumbUp,
  cilTrash,
  cilUser,
  cilAddressBook,
  cilListRich,
  cilCommentBubble,
  cilHospital,
  cilHome,
  cilHamburgerMenu,
  cilStar,
  cilStarHalf,
  cilSearch,
  cilCart,
  cilCloudUpload,
  cilExpandDown,
  cilArrowLeft,
  cilArrowRight,
  cilArrowTop,
  cilListLowPriority,
  cilTags,
  cilOptions,
  cilArrowBottom,
  cilCreditCard,
  cilCloudDownload,
  cilCheck,
  cilCode,
  cilCopy,
  cilInfo,
  cilX,
  cilMonitor,
  cilSync,
  cilSwapHorizontal,
  cilWarning
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilBan,
    cilBoltCircle,
    cilCasino,
    cilEnvelopeClosed,
    cilGroup,
    cilHighlighter,
    cilReload,
    cilHttps,
    cilLibraryAdd,
    cilLockLocked,
    cilLockUnlocked,
    cilLowVision,
    cilListLowPriority,
    cilMagnifyingGlass,
    cilMediaSkipBackward,
    cilMediaSkipForward,
    cilMoon,
    cilMenu,
    cilPlus,
    cilX,
    cilSpeedometer,
    cilStorage,
    cilSun,
    cilSearch,
    cilThumbDown,
    cilThumbUp,
    cilTrash,
    cilUser,
    cilTags,
    cilAddressBook,
    cilListRich,
    cilCommentBubble,
    cilHospital,
    cilHome,
    cilHamburgerMenu,
    cilStar,
    cilStarHalf,
    cilCart,
    cilCreditCard,
    cilInfo,
    cilCloudUpload,
    cilCloudDownload,
    cilCheck,
    cilCode,
    cilCopy,
    cilExpandDown,
    cilArrowLeft,
    cilArrowRight,
    cilArrowTop,
    cilArrowBottom,
    cilOptions,
    cilMonitor,
    cilSync,
    cilSwapHorizontal,
    cilWarning
  }
)
